import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { companyManagementUrl } from "../../../config";

import { useEffect, useState } from "react";

import { PulseLoader } from "react-spinners";
import {
  CompanyColumns,
  RegionsColumns,
} from "../../../data/DynamicTable/CompanyManagementColumns";
import CompanyForm from "./form";
import { allCompanies, allRegions } from "../../../data/Axios/queries";
import RegionForm from "./form";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";

const base_url = companyManagementUrl.uri;

const regionsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This Page is all about Regions, where you can Creates, edit activate or deactivate the Region.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific Region by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Region.",
    placement: "right",
  },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  {
    target: ".dynamic-table-actions",
    content: "Select actions like Edit or Deactivate for each Regions from this dropdown.",
    placement: "left",
  },
];
const actions = {
  entity: "Regions",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  dataObject: {
    objectName: "region",
    parameters: "",
  },
  showStatus: true,
  showMore:{
    search:false,
    min: 0,
    max:0
  }
};
function RegionTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTableForJson
          title="Region"
          subtitle="Create, view or edit  Region"
          columns={RegionsColumns}
          FormComponent={RegionForm}
          query={allRegions}
          base_url={base_url}
          actions={actions}
               tourSteps={regionsTourSteps} // Pass tour steps as prop
        />
      </>
    </Box>
  );
}

export default RegionTable;
